var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-data-table", {
        staticStyle: { "white-space": "nowrap" },
        attrs: {
          headers: _vm.headers,
          items: _vm.localItems,
          "hide-default-header": _vm.empty,
          height: _vm.localItems.length > 7 ? 32 * 7 + 32 + 16 : undefined,
          "disable-pagination": "",
          "hide-default-footer": "",
          dense: "",
          "item-key": "string",
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function () {
              return [
                _c(
                  "v-toolbar",
                  { attrs: { flat: "", dense: "" } },
                  [
                    _c("v-toolbar-title", [_vm._v("Groups")]),
                    _c("v-divider", {
                      staticClass: "mx-2",
                      attrs: { inset: "", vertical: "" },
                    }),
                    !_vm.readonly
                      ? _c(
                          "v-btn",
                          {
                            staticClass: "ma-2",
                            attrs: { small: "", color: "primary" },
                            on: { click: _vm.row_create },
                          },
                          [_vm._v("Add")]
                        )
                      : _vm._e(),
                    _c("v-spacer"),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "draggable",
                  {
                    attrs: { handle: ".drag-handle", tag: "tbody" },
                    on: { change: _vm.onDragChange },
                    model: {
                      value: _vm.localItems,
                      callback: function ($$v) {
                        _vm.localItems = $$v
                      },
                      expression: "localItems",
                    },
                  },
                  _vm._l(_vm.localItems, function (item, index) {
                    return _c("tr", { key: item.uid || item.id || index }, [
                      _c("td", [_vm._v(_vm._s(item.name))]),
                      _c(
                        "td",
                        { staticClass: "text-right" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { small: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.row_update(item, index)
                                },
                              },
                            },
                            [_vm._v("mdi-pencil")]
                          ),
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2 drag-handle",
                              attrs: { small: "" },
                            },
                            [_vm._v("mdi-drag")]
                          ),
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-2",
                              attrs: { small: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.row_remove(item)
                                },
                              },
                            },
                            [_vm._v("mdi-delete")]
                          ),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("c-group-dialog", { ref: "dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }